export const hideOnWidthClassname = (
  variant: "hide-on-small" | "hide-on-large",
  breakpoint: number,
) => `hide-if-${variant}-${breakpoint}`;

export const hideOnWidthStyle = (breakpoint: number) => `
    container-type: inline-size;
    @container (width < ${breakpoint}px) {
      .${hideOnWidthClassname("hide-on-small", breakpoint)} {
        display: none;
      }
    }
    @container (width >= ${breakpoint}px) {
      .${hideOnWidthClassname("hide-on-large", breakpoint)} {
        display: none;
      }
    }
`;
